import { connectRouter } from "connected-react-router";
import { localizeReducer } from "react-localize-redux";
import { combineReducers } from "redux";

//Reducers
import alert from "../components/alert/reducer.js";
import auth from "./auth.js";
import balance from "./balance.js";
import bonus from "./bonus.js";
import chat from "./chat.js";
import cms from "./cms.js";
import common from "./common.js";
import coupon from "./coupon.js";
import deposit from "./deposit.js";
import documents from "./documents.js";
import live from "./live.js";
import match from "./match.js";
import profile from "./profile.js";
import stats from "./stats.js";
import thirdParty from "./thirdParty.js";
import tournament from "./tournament.js";
import websocket from "./websocket.js";
import withdraw from "./withdraw.js";

export default (history, extraReducers = {}) =>
	combineReducers({
		localize: localizeReducer,
		router: connectRouter(history),
		auth,
		match,
		tournament,
		stats,
		balance,
		websocket,
		live,
		profile,
		thirdParty,
		coupon,
		cms,
		documents,
		common,
		alert,
		deposit,
		withdraw,
		bonus,
		chat,
		...extraReducers,
	});
